import { CapsuleType } from '@bit/amit.capsule-dev.remote-capsule';

export function mapLegacyCapsuleTypes(type: CapsuleType | string): CapsuleType {
	switch (type) {
		//@HACK! 'react' capsule should be invalid. remove this
		case 'bit.rendering/renderers/react@0.0.1':
		case 'bit.rendering/renderers/react':
		case 'bit.rendering/renderers/vanilla@0.0.1':
		case 'bit.rendering/renderers/vanilla':
		case 'react':
			return CapsuleType.react;
		default:
			//🤞 hope this works!
			return type as CapsuleType;
	}
}
